import restApi from "@plannel/services/utils/rest-api";

const getAll = (params) => {
  return restApi.post("/api/sales-txn", params);
};

const getAllForCSV = params => {
  return restApi.post("/api/sales-txn/csv", params);
};

const upsert = data => {
  return restApi.post("/api/sales-txn/save", data);
};

const remove = ids => {
  return restApi.delete(`/api/sales-txn/${ids}`);
};

// 실판매 최신 적재 일자만 조회 — { latestDate } (홈 파이프라인 "판매실적" 상태용, 경량)
const getLatestDate = () => {
  return restApi.get("/api/sales-txn/latest-date");
};

const getTopItem = (params) => {
  return restApi.get("/api/sales-txn/top-item", { params });
};

const getItemCustSum = (params) => {
  return restApi.get("/api/sales-txn/item-cust-summary", { params })
};

const salesTxnService = {
  getAll,
  getAllForCSV,
  upsert,
  remove,
  getLatestDate,
  getTopItem,
  getItemCustSum
};

export default salesTxnService;